import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Form, { Field } from "rc-field-form";
import { Card, CardHeader, Row, Col } from "reactstrap";
import Button from "../../../../../components/Button";
import Topbar from "../../components/Topbar";
import Settings from "./Settings";
import { useConfigurationModule } from "../../hooks/useConfigurationModule";
import { useConfigurationActions } from "../../api/useConfiguration";
import "../style.scss";

const options = ["settings"];

function General() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const config = useConfigurationModule("timeSheetGeneral");
    const [menu, setMenu] = useState("settings")

    const content = useMemo(() => {
        switch (menu) {
            case "settings":
                return <Settings form={form} />;
            default:
                return;
        }
    }, [menu, form]);

    const { submit, submitting } = useConfigurationActions("timeSheetGeneral");
    const onFinish = useCallback(async (formValues) => {
        try {
            await submit({
                entity: "company",
                config: formValues,
            });
        } catch (err) { }
    }, [submit]);

    useEffect(() => {
        form.setFieldsValue({
            replaceJobWhenItIsChanged: config?.replaceJobWhenItIsChanged || false,
            calculateOverMultipleProfiles: config?.calculateOverMultipleProfiles || false,
            hideRetroAdjustment: config?.hideRetroAdjustment || false,
            method: config?.method
        })
    }, [form, config]);

    return <div className="d-flex h-100 configuration">
        <Card className="flex-fill mb-0 h-100">
            <Form form={form} onFinish={onFinish} style={{ height: "calc(100% - 160px)" }}>
                <CardHeader>
                    <Row>
                        <Col xs="6" className="pl-4 d-flex">
                            <h3 className="mb-0 mr-5">{t("general")}</h3>
                        </Col>

                        <Col className="text-right" xs="6">
                            <Button
                                className="btn-dark px-3 btn-round btn-icon"
                                size="sm"
                                loading={submitting}
                                type="submit"
                            >
                                {t("save")}
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>

                <Topbar
                    options={options}
                    menu={menu}
                    setMenu={setMenu}
                />

                <div
                    className="w-100 d-flex h-100 flex-wrap gap-20 scroll p-4"
                    style={{ overflow: "auto" }}
                >
                    <Field name="replaceJobWhenItIsChanged" valuePropName="checked" />
                    <Field name="calculateOverMultipleProfiles" valuePropName="checked" />
                    <Field name="hideRetroAdjustment" valuePropName="checked" />
                    <Field name="method" />

                    {content}
                </div>
            </Form>
        </Card>
    </div >
}

export default General;
